<template>
  <div class="register--root">
    <div class="contain">

      <div class="register--body">
        <div class="register--header">
          <h1 class="register--title">Register</h1>
          <p class="register--desc">
             Welcome to Sudan Crisis Coordination Unit (SCCU) registration.
          </p>
        </div>

        <form class="ui form register--form">
          <div class="field two fields">
            <div class="field" :class="{ error: errors.firstName }">
              <label>First Name</label>
              <input type="text" v-model="firstName" placeholder="First Name" required>
              <div class="ui red pointing label" v-if="errors.firstName">{{ errors.firstName }}</div>
            </div>
            <div class="field" :class="{ error: errors.lastName }">
              <label>Last Name</label>
              <input type="text" v-model="lastName" placeholder="Last Name" required>
              <div class="ui red pointing label" v-if="errors.lastName">{{ errors.lastName }}</div>
          </div>
          </div>
          <div class="field" :class="{ error: errors.email }">
            <label>Email</label>
            <input type="email" v-model="email" placeholder="Email" required>
            <div class="ui red pointing label" v-if="errors.email">{{ errors.email }}</div>
          </div>
          <div class="field" :class="{ error: errors.phone }">
            <label>Phone</label>
            <input type="text" v-model="phone" placeholder="Phone" required>
            <div class="ui red pointing label" v-if="errors.phone">{{ errors.phone }}</div>
          </div>
          <div class="field" :class="{ error: errors.pass }">
            <label>Password</label>
            <input type="password" v-model="pass" placeholder="Password" required>
            <div class="ui red pointing label" v-if="errors.pass">{{ errors.pass }}</div>
          </div>
          <div class="field" :class="{ error: errors.confirmPass }">
            <label>Confirm Password</label>
            <input type="password" v-model="confirmPass" placeholder="Confirm Password" required>
            <div class="ui red pointing label" v-if="errors.confirmPass">{{ errors.confirmPass }}</div>
          </div>
          <div class="sc--btn--group">
            <button href="#!" class="sc--btn" type="submit" @click.prevent="submitForm">
              Sign up
            </button>
          </div>
        </form>
        <div class="ui error message transition" v-show="formValidate">
          <i class="close icon" @click="formValidate = false"></i>
          <div class="header">
            There were some errors with your submission
          </div>
          <ul class="list">
            <li>{{ errors.formResponse }}</li>
          </ul>
        </div>
        <div class="register--text">
          <p>
            have an account?
          </p>
          <router-link to="/login">Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import jQuery from 'jquery';
export default {
  name: 'registerPage',
  metaInfo: {
    title: 'Register',
    meta: [
      { name: 'description', content: 'Register' },
      { property: 'og:title', content: 'Register' },
      { property: 'og:description', content: 'Register' },
    ]
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      pass: '',
      confirmPass: '',
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        pass: '',
        confirmPass: '',
        formResponse: ''
      },
      formValidate: false,
    }
  },
  methods: {
    getBearerToken() {
      // get username from email before @ sign
      const username = this.email.substring(0, this.email.indexOf('@'));
      fetch('/wp-json/simple-jwt-authentication/v1/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username,
          password: this.pass
        })
      }).then(response => response.json())
        .then(data => {
          console.log(data);
          localStorage.setItem('sjdifjsckdsjfosdf54520bearer', data.token);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    },
    async submitForm() {
      this.validateForm();
      if (this.formIsValid()) {
        try {
          const response = await fetch('/wp-json/custom/v1/register', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              first_name: this.firstName,
              last_name: this.lastName,
              email: this.email,
              phone: this.phone,
              password: this.pass,
            })
          });

          const responseData = await response.json();

          if (response.ok && responseData.success) {
            // Registration successful
            console.log('User registered:', responseData);
            localStorage.setItem('sjdifjsckdsjfosdf54520yyy', responseData.token);
            localStorage.setItem('sjdifjsckdsjfosdf54520zzz', parseInt(responseData.id));
            localStorage.setItem('sjdifjsckdsjfosdf54520uuu', parseInt(responseData.username));

            // Redirect or perform other actions for authenticated users
            // redirect window to login page
            this.$router.push('/dashboard');
          } else {
            // Registration failed
            console.error('Registration failed:', responseData);
            this.errors.formResponse = responseData.message || 'Registration failed';
            this.formValidate = true;
          }
        } catch (error) {
          console.error('An error occurred:', error);
        }
        this.getBearerToken();
      }
    },

    validateForm() {
      this.errors.firstName = this.firstName ? '' : 'Please enter your first name';
      this.errors.lastName = this.lastName ? '' : 'Please enter your last name';
      this.errors.email = this.email ? '' : 'Please enter your email';
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (this.email && !emailRegex.test(this.email)) {
        this.errors.email = 'Please enter a valid email address';
      }
      this.errors.phone = this.phone ? '' : 'Please enter your phone number';
      // You can add more specific phone number validation here if needed
      this.errors.pass = this.pass ? '' : 'Please enter a password';
      if (this.pass && this.pass.length < 6) {
        this.errors.pass = 'Your password must be at least 6 characters';
      }
      this.errors.confirmPass = this.confirmPass ? '' : 'Please confirm your password';
      if (this.pass !== this.confirmPass) {
        this.errors.confirmPass = 'Passwords do not match';
      }
    },
    formIsValid() {
      return (
        !this.errors.firstName &&
        !this.errors.lastName &&
        !this.errors.email &&
        !this.errors.phone &&
        !this.errors.pass &&
        !this.errors.confirmPass
      );
    }
  }
}


</script>

<style lang="sass">

  @import '../assets/css/public'

  .register--root
    .contain
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column

      .register--body
        width: 450px
        max-width: 100%
        margin-top: 50px

      .register--form
        background: $light-gray
        padding: 50px
        margin-top: 50px
        +lines-border(5px)

        input
          border: 1px solid $black

        label
          font-size: 16px
          color: $sec-purple
          margin-bottom: 7px

        .sc--btn
          margin-top: 20px

      .register--header

        .register--title
          font-size: 40px
          margin-bottom: 10px
          color: $black

        .register--desc
          font-size: 16px
          color: $text-gray

      .register--text
        display: flex
        align-items: center
        justify-content: flex-start
        flex-wrap: wrap
        margin-top: 20px
        
        p
          font-size: 16px
          color: $text-gray
          margin-bottom: 0
          margin-right: 10px

        a
          font-family: PP-Medium
          font-size: 16px
</style>